import { breakpoints } from "shared/ui";

import { IikoIntegrationStep } from "features/IikoIntegration/types";

export const STEPS: { step: IikoIntegrationStep; label: string }[] = [
    { step: 1, label: "Ключ" },
    { step: 2, label: "Организация" },
    { step: 3, label: "Источник меню" },
    { step: 4, label: "Терминалы" },
    { step: 5, label: "Синхронизация" },
];

// Узкий вьюпорт кита: ниже него степпер сворачивается в строку с полосой прогресса.
export const MOBILE_BREAKPOINT = breakpoints.mobile;

export const API_KEY_HINT =
    "Личный кабинет iiko → Администрирование → Внешние приложения → Transport API";
